module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_troms_og_finnmark_neg.7c097b02.pdf";